import React, { useState } from 'react';
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { unimel_logo_hor } from '../assets';
import ReportModal from './reportPage';
import SideMenu from './side-menu';


/**
 * Sidebar component that toggles between History and Main views.
 * 
 * @returns {JSX.Element} - The rendered Sidebar component.
 */
const Sidebar = ({isOpen, setIsOpen}) => {
  // State to manage the current view (History or Main)

  return (
    <div className="flex">
      {/* Sidebar */}
      <div
        className={`min-h-[100vh] font-Inter z-20 fixed border-r bg-white border-gray-200 top-0 left-0 h-full overflow-y-auto w-80 transition-transform duration-300 lg:relative ${
          isOpen ? "translate-x-0" : "-translate-x-full lg:-translate-x-80"
        }`}
      >
        <div className="mt-6 px-6 flex justify-end">
          <img
            src={unimel_logo_hor}
            alt="Logo"
            className="h-12 w-auto"
          />
        </div>
      
        <SideMenu title="History" isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>

      {/* Toggle Button (Always Visible) */}
      <button
        className={`fixed top-20 transition-all duration-300 z-50 text-2xl p-2 rounded-md ${
          isOpen ? "left-64" : "left-4"
        }`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
      </button>
    </div>    
  );
};

export default Sidebar;
